<script setup lang="ts">
import type { FormKitFrameworkContext } from "@formkit/core";
import type { PropType } from "vue";

import { DATA_TEST_IDS } from "@/constants/data-test-ids";
import { useFormkitComputedValue } from "@/hooks/common/use-formkit.ts";

import InputNumber from "primevue/inputnumber";

export interface FormKitPrimeInputNumberProps {
  placeholder?: string;
  disabled?: boolean;
  optional?: boolean;
}

const props = defineProps({
  context: {
    type: Object as PropType<FormKitFrameworkContext & FormKitPrimeInputNumberProps>,
  },
});

const value = useFormkitComputedValue(props.context);
</script>

<template>
  <InputNumber
    v-bind="$attrs"
    :id="props.context?.id"
    v-model="value"
    :placeholder="props.context?.placeholder"
    :disabled="props.context?.disabled"
    class="w-full"
    :class="[props.context?.class]"
    :data-test-id="DATA_TEST_IDS.components.uiNumberInput.component"
  />
</template>
